import cn from "classnames";
import styles from "./ProductFiles.module.sass";
import Card from "../../../components/Card";
import File from "../../../components/File";
import Icon from "../../../components/Icon";

const ProductFiles = ({ className, offer, onOfferChange, loading, onSave }) => {
    
    const handleFileChange = (file) => {
        if (onOfferChange && file) {
            // Stocker le fichier entier pour l'upload vers PocketBase
            onOfferChange({
                target: {
                    name: 'job_description',
                    value: file 
                }
            });
            console.log('Fichier sélectionné:', file.name, file.type, file.size);
        }
    };

    const handleFileRemove = () => {
        if (onOfferChange) {
            onOfferChange({
                target: {
                    name: 'job_description',
                    value: null
                }
            });
        }
    };

    // Vérifier si un fichier est sélectionné
    const selectedFile = offer?.job_description;
    const hasFile = selectedFile && typeof selectedFile === 'object' && selectedFile.name && selectedFile.size;

    return (
        <Card
            className={cn(styles.card, className)}
            title="Fiche de poste"
            classTitle="title-blue"
        >
            <div className={styles.files}>
                {!hasFile ? (
                    <File
                        className={styles.field}
                        title="Déposer un fichier"
                        label="Fiche de poste (optionnel)"
                        tooltip="Formats acceptés: PDF, DOC, DOCX. Taille maximum: 10MB"
                        onChange={handleFileChange}
                    />
                ) : (
                    <div className={styles.field}>
                        <div className={styles.label}>
                            Fiche de poste (optionnel)
                        </div>
                        <div className={styles.fileSelected}>
                            <div className={styles.fileInfo}>
                                <div className={styles.avatar}>
                                    <img src={'/images/content/convention_logo.png'} alt="Logo" />
                                </div>
                                <span className={styles.fileName}>{selectedFile.name}</span>
                                <span className={styles.fileSize}>
                                    ({(selectedFile.size / 1024).toFixed(1)} KB)
                                </span>
                            </div>
                            <button
                                type="button"
                                className={styles.removeButton}
                                onClick={handleFileRemove}
                                title="Supprimer le fichier"
                            >
                                <Icon name="close" size="16" />
                            </button>
                        </div>
                    </div>
                )}
            </div>

            <div className={styles.divider}></div>

            <div className={styles.actions}>
                <button
                    className={cn("button", styles.button)}
                    type="button"
                    disabled={loading}
                    onClick={onSave}
                >
                    {loading ? "Création en cours..." : "Créer l'offre d'alternance"}
                </button>
            </div>
        </Card>
    );
};

export default ProductFiles;
